const LOG_PREFIX = "[GoogleLogin]";

const safeString = (value) => {
  if (value == null) return value;
  return String(value);
};

export const getGoogleLoginEnvironment = (clientId = "") => {
  if (typeof window === "undefined") {
    return { available: false };
  }

  return {
    available: true,
    origin: window.location.origin,
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    href: window.location.href,
    userAgent: window.navigator.userAgent,
    crossOriginIsolated: window.crossOriginIsolated,
    hasGoogleAccounts: Boolean(window.google?.accounts),
    hasGoogleOAuth2: Boolean(window.google?.accounts?.oauth2),
    clientIdConfigured: Boolean(clientId),
    clientIdSuffix: clientId ? clientId.slice(-12) : null,
  };
};

export const sanitizeTokenResponse = (tokenResponse = {}) => ({
  hasAccessToken: Boolean(tokenResponse.access_token),
  accessTokenLength: tokenResponse.access_token?.length || 0,
  tokenType: tokenResponse.token_type || null,
  expiresIn: tokenResponse.expires_in ?? null,
  scope: tokenResponse.scope || null,
  authuser: tokenResponse.authuser ?? null,
  prompt: tokenResponse.prompt ?? null,
});

export const sanitizeUserInfo = (details = {}) => ({
  hasSub: Boolean(details.sub),
  googleIdSuffix: details.sub ? safeString(details.sub).slice(-8) : null,
  hasEmail: Boolean(details.email),
  emailDomain: details.email?.includes("@")
    ? details.email.split("@")[1]
    : null,
  hasGivenName: Boolean(details.given_name),
  hasFamilyName: Boolean(details.family_name),
  hasPicture: Boolean(details.picture),
});

export const sanitizeApiResponse = (payload = {}) => ({
  status: payload?.status ?? null,
  message: payload?.message || null,
  profileSteps: payload?.data?.profileSteps ?? null,
  hasAccessToken: Boolean(payload?.data?.accessToken),
  userIdSuffix: payload?.data?._id
    ? safeString(payload.data._id).slice(-6)
    : null,
});

export const logGoogleLogin = (flow, step, data = {}) => {
  console.log(`${LOG_PREFIX} [${flow}] ${step}`, {
    flow,
    step,
    timestamp: new Date().toISOString(),
    ...data,
  });
};

export const logGoogleLoginError = (flow, step, error, data = {}) => {
  console.error(`${LOG_PREFIX} [${flow}] ${step} FAILED`, {
    flow,
    step,
    timestamp: new Date().toISOString(),
    message: error?.message || safeString(error),
    name: error?.name || null,
    code: error?.code || null,
    type: error?.type || null,
    ...data,
    error,
  });
};
